/* eslint-disable max-len */
import React from 'react';
import SocialShareHorizontal from '../../molecules/social-share/social-share-horizontal';
import GoogleBadge from '../../molecules/google-badge';

import './join-official-channels.m.css';

const JoinOfficialChannels = ({ sectionName }) => (
  <div styleName="join-us-wrap">
    <div styleName="social-share">
      <SocialShareHorizontal sectionName={sectionName} isTwitter />
      <GoogleBadge position="social-badge" />
    </div>
  </div>
);

export default JoinOfficialChannels;
